export default __webpack_public_path__ + "static/location-map-30c5c0f343370b4cc53523244e9fa720.svg";